import ajax from "./ajax";
export function getFaqs() {
  return ajax(`/Faq/getAllFaqs?sort=display_order&per-page=1000`);
}